import { clientsAPI } from 'api/clientsAPI'
import { useQuery } from '@tanstack/react-query'
import useSelectOptions from './useSelectOptions'

export default function useClients() {
  // const currentUser = useSelector((state: any) => state.users.user)
  // const currentClient = useSelector((state: any) => state.clients.client)

  // const isTravellerOnly =
  //   currentUser.roles.length === 1 && currentUser.roles.includes('Traveller')

  const query = useQuery({
    queryKey: ['clients'],
    queryFn: () => {
      return clientsAPI.searchClients()
    },
  })

  const response = query.data
  const clients = response?.data?.value

  const options = useSelectOptions(clients, {
    label: (client) => client.companyName,
    value: (client) => client.id,
  })

  return { clients, options, ...query }
}
